import { PenNameTab } from './PenNameTab'
import { withPenNameTab } from './withPenNameTab'

const ConnectedPenNameTab = withPenNameTab(PenNameTab)

export { ConnectedPenNameTab as PenNameTab }
